/*
 * @Description: 个体
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { eContract, projectSettled } from '@/api/ajax';

const example = new TableRenderClass({ fields, search });

export const exportNames = example.createPart({
  name: '导入名单',
  search: [
    'userName',
    'zooidEnterpriseName',
    'phone',
    'certificationStatus',
    'status',
    'certificationUpload'
  ],
  list: projectSettled.projectSettledInList,
  defaultQuery: { _qualificationAuditParams: { type: 1 } },
  requestNow: true,
  fields: [
    'selection',
    'index',
    'userName',
    'zooidEnterpriseName',
    'phone',
    'certificationUpload',
    'auditOssStatus',
    'settledInDt',
    'status',
    'importOperation'
  ]
});

export const applyNames = example.createPart({
  name: '申请名单',
  search: [
    'userName',
    'zooidEnterpriseName',
    'phone',
    'checkStatus',
    'applyCertificationStatus',
    'enterStatus'
  ],
  list: projectSettled.userEnterProjectPageList,
  defaultQuery: { _qualificationAuditParams: { type: 2 } },
  requestNow: true,
  // FIXME: 暂时使用。申请名单去掉多选并禁用审核。selection，importOperation
  fields: [
    // 'selection',
    'index',
    'userName',
    'zooidEnterpriseName',
    'phone',
    {
      label: '入驻时间',
      prop: 'enterTime'
    },
    {
      label: '入驻状态',
      prop: 'enterStatus'
    },
    'auditOssStatus',
    'checkStatus',
    'applyHandler'
    // 'importOperation'
  ]
});
